import { useIntlayer } from 'react-intlayer';

import { LocalizedLink } from '~/components/LocalizedLink';
import { SOCIAL_LINKS } from '~/constants';

export const Footer = () => {
  const content = useIntlayer('footer');

  return (
    <footer className="bg-black px-4 py-10 md:px-20" style={{ contentVisibility: 'auto', containIntrinsicSize: '400px' }}>
      <div className="max-w-[1440px] mx-auto flex flex-col gap-[60px]">
        {/* Mobile: Logo at top, Desktop: Logo on left */}
        <div className="flex flex-col md:flex-row items-start justify-between gap-[60px] md:gap-4">
          {/* Logo */}
          <div className="shrink-0">
            <img
              src="/assets/images/trypillian-logo-white-horizontal.svg"
              alt="Trypillian"
              className="h-5 w-auto md:h-6"
            />
          </div>

          {/* Footer columns - mobile: stacked, desktop: horizontal */}
          <div className="flex flex-col md:flex-row gap-10 md:gap-[80px] w-full md:w-auto md:justify-end">
            {/* Address */}
            <div className="flex flex-col gap-3 md:gap-[18px] w-full md:w-[131px]">
              <p className="font-mono text-xs tracking-[0.12px] uppercase text-[#7b8d9e]">
                {content.address.title}
              </p>
              <div className="text-sm text-white tracking-[0.14px]">
                <p className="mb-0">{content.address.street}</p>
                <p className="mb-0">{content.address.city}</p>
                <p className="">{content.address.country}</p>
              </div>
            </div>

            {/* Main */}
            <div className="flex flex-col gap-3 md:gap-[18px] w-full md:w-[67px]">
              <p className="font-mono text-xs tracking-[0.12px] uppercase text-[#7b8d9e]">
                {content.main.title}
              </p>
              <div className="flex flex-col gap-2 md:gap-3 text-sm text-white tracking-[0.14px]">
                {/* <LocalizedLink to="/mission" className="hover:text-white/70 transition-colors">
                  {content.main.mission}
                </LocalizedLink>
                <LocalizedLink to="/vision" className="hover:text-white/70 transition-colors">
                  {content.main.vision}
                </LocalizedLink> */}
                <LocalizedLink to="#products" className="hover:text-white/70 transition-colors">
                  {content.main.products}
                </LocalizedLink>
                {/* <LocalizedLink to="/founders" className="hover:text-white/70 transition-colors">
                  {content.main.founders}
                </LocalizedLink> */}
                <a
                  href={SOCIAL_LINKS.LINKEDIN}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-white tracking-[0.14px] hover:text-white/70 transition-colors"
                >
                  {content.main.vacancies}
                </a>
                <a
                  href={SOCIAL_LINKS.LINKEDIN}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-white tracking-[0.14px] hover:text-white/70 transition-colors"
                >
                  {content.main.contacts}
                </a>
              </div>
            </div>

            {/* Support */}
            <div className="flex flex-col gap-3 md:gap-[18px] w-full md:w-[96px]">
              <p className="font-mono text-xs tracking-[0.12px] uppercase text-[#7b8d9e]">
                {content.support.title}
              </p>
              <div className="flex flex-col gap-2 md:gap-3 text-sm text-white tracking-[0.14px]">
                <LocalizedLink to="/privacy" className="hover:text-white/70 transition-colors">
                  {content.support.privacyPolicy}
                </LocalizedLink>
                <LocalizedLink to="/cookies" className="hover:text-white/70 transition-colors">
                  {content.support.cookiesPolicy}
                </LocalizedLink>
              </div>
            </div>

            {/* Quick Contact */}
            <div className="flex flex-col gap-3 md:gap-[18px] w-full md:w-auto">
              <p className="font-mono text-xs tracking-[0.12px] uppercase text-[#7b8d9e]">
                {content.quickContact.title}
              </p>
              <a
                href={SOCIAL_LINKS.LINKEDIN}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-white tracking-[0.14px] hover:text-white/70 transition-colors"
              >
                {content.quickContact.linkedin}
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <p className="text-sm text-white tracking-[0.14px]">
          {content.copyright}
        </p>
      </div>
    </footer>
  );
};
